import React, { Component } from "react";
import PropTypes from "prop-types";
import "antd/dist/antd.css";
import IndexLinkItem from "./indexLinkItem";

class IndexLinkList extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#0050B3",
  };
  // 静态类型分析
  static propTypes = {
    urlPic: PropTypes.string.isRequired, //图片
    urlName: PropTypes.string.isRequired, //名称
    urlAddress: PropTypes.string.isRequired, //链接地址
    urlStatus: PropTypes.string.isRequired, //状态
    createTime: PropTypes.string.isRequired, //创建时间
    id: PropTypes.number.isRequired, //创建时间
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div style={{ width: "100%" }}>
        <table
          locale={{ emptyText: '暂无数据' }}
          style={{
            border: "1px solid #666",
            textAlign: "center",
          }}
        >
          <tbody>
            <tr
              style={{
                border: "1px solid #e6e6e6",
                backgroundColor: "#fff",
                height: "30px",
                lineHeight: "30px",
              }}
            >
              <td style={{ width: "316px" }}>
                <img
                  style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                  src={this.props.urlPic}
                  alt=""
                />
              </td>
              <td style={{ width: "316px" }}>{this.props.urlName}</td>
              <td style={{ width: "316px" }}>{this.props.urlAddress}</td>
              <td style={{ width: "316px" }}>
                {this.props.urlStatus === "flase" ? "禁用" : "启用"}
              </td>
              <td style={{ width: "316px" }}>{this.props.createTime}</td>
              <td style={{ width: "316px" }}>
                <div onClick={this.editItem} style={{ marginRight: "8px", cursor: "pointer" }}>
                  编辑
                </div>
                <IndexLinkItem
                  newSecondSelectColor={this.props.newSecondSelectColor}
                  ref="indexLinkItem"
                  urlPic={this.props.urlPic}
                  urlName={this.props.urlName}
                  urlAddress={this.props.urlAddress}
                  urlStatus={this.props.urlStatus}
                  changeDate={this.props.changeDate}
                  createBy={this.props.createBy}
                  createTime={this.props.createTime}
                  getEditUpdateData={(edit) =>
                    this.props.getEditUpdateData(edit)
                  }
                />
                <div style={{ marginRight: "8px", color: "red", cursor: "pointer" }} onClick={() => this.props.del()}>
                  删除
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
  editItem = () => {
    // let id = this.props.id;
    // this.refs.indexLinkItem.showModal(id);
    this.editST();
  };
  editST() {
    let layer = window.layui.layer;
    let id = this.props.id;
    let url = "/cm-sites/pms/mediaFusion/homeLinkEdit.html?id=" + id;
    layer.open({
      title: "编辑链接",
      type: 2,
      content: url,
      area: ["700px", "430px"],
      resize: true,
    });
  }
}

export default IndexLinkList;
